/**
 * Cliente HTTP para los endpoints DEV del catálogo de partículas.
 *
 * Solo funciona si el server corre en DEV (NODE_ENV !== production).
 * El server filtra por el guard interno del router.
 */

import type { ParticleEffectDefV2 } from '@shared/types/particles';
import { SERVER_CONFIG } from '@shared/constants';

const SERVER_BASE =
  (import.meta.env.VITE_SERVER_HTTP_URL as string | undefined) ??
  `http://${window.location.hostname}:${SERVER_CONFIG.PORT}`;

const BASE = `${SERVER_BASE}/__dev/particles`;

export async function listFx(): Promise<Record<string, ParticleEffectDefV2>> {
  const res = await fetch(`${BASE}/list`);
  if (!res.ok) throw new Error(`list failed: ${res.status}`);
  return (await res.json()) as Record<string, ParticleEffectDefV2>;
}

export async function saveFx(id: string, def: ParticleEffectDefV2): Promise<void> {
  const res = await fetch(`${BASE}/save`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, def }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText })) as { error?: string };
    throw new Error(err.error ?? `save failed: ${res.status}`);
  }
  // Notificar a otras pestañas (GameScene) que hay cambios.
  try {
    window.localStorage.setItem('aureum:particles:reload', String(Date.now()));
  } catch {
    /* SSR-safe */
  }
}

export async function deleteFx(id: string): Promise<void> {
  const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText })) as { error?: string };
    throw new Error(err.error ?? `delete failed: ${res.status}`);
  }
  try {
    window.localStorage.setItem('aureum:particles:reload', String(Date.now()));
  } catch {
    /* SSR-safe */
  }
}
